<script setup lang="ts">
import { isNotEmpty } from '@/utils/util'
import { computed, type PropType } from 'vue'
import type { FileDTO } from '@/composables/media/media'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false,
    default: ''
  },
  selected: {
    type: Boolean,
    required: false,
    default: false
  }
  // avatar: {
  //   type: Object as PropType<FileDTO>,
  //   required: true
  // }
})

const selctedVal = computed(() => {
  // console.log("props.selected:", props.selected);
  return props.selected
})

// const avatarRef = computed(() => {
//   return props.avatar
// })
</script>
<template>
  <div flex="~ row" cursor-pointer items-center pr-2 menu-item :class="selctedVal ? 'bg-m-gradient' : ''">
    <div
      v-if="isNotEmpty(icon)"
      :class="props.icon"
      ml-3
      min-w-5
      min-h-5
      text-xl
      text-third
      inline-block
      @click="$emit('onSelect')"></div>
    <div grow truncate py-2.5 pl-4 text-left @click="$emit('onSelect')">{{ props.name }}</div>
    <div>
      <slot name="action"></slot>
    </div>
  </div>
</template>
<style lang="" scoped></style>
